import dayjs from 'dayjs';
import { Role, UserIdentityProvider } from 'graphql/generated/graphqlTypes';
import { generateMockMobileDevice } from './mobileDevice';
import { generateMockVisitor } from './visitor';
import {
  mockVisitorGroupAlpha,
  mockVisitorGroupBeta,
  mockVisitorGroupCardHolders,
  mockVisitorGroupCleaners,
  mockVisitorGroupCoContractors,
  mockVisitorGroupCognitoTeam,
  mockVisitorGroupDelta,
  mockVisitorGroupEntraTeam,
  mockVisitorGroupEpsilon,
  mockVisitorGroupEta,
  mockVisitorGroupGamma,
  mockVisitorGroupInstallers,
  mockVisitorGroupInternalTeam,
  mockVisitorGroupIota,
  mockVisitorGroupKappa,
  mockVisitorGroupKeySharingUsers,
  mockVisitorGroupLambda,
  mockVisitorGroupMu,
  mockVisitorGroupNu,
  mockVisitorGroupOmicron,
  mockVisitorGroupTheta,
  mockVisitorGroupXi,
  mockVisitorGroupZeta
} from './visitorGroupFixtures';
import { generateMockVisitorGroupMembership } from './visitorGroupMembership';

export const mockVisitorInstaller = generateMockVisitor({
  id: 'mockVisitorId1',
  name: 'Dennis Tegelwerker',
  email: 'd.tegelwerker@tkhsecurity.com',
  visitorGroupMembership: [generateMockVisitorGroupMembership({ visitorGroup: mockVisitorGroupInstallers })]
});

export const mockVisitorInstaller2 = generateMockVisitor({
  id: 'mockVisitorInstaller2',
  name: 'Pieter van den Berg',
  email: 'p.vandenberg@tkhsecurity.com',
  visitorGroupMembership: [generateMockVisitorGroupMembership({ visitorGroup: mockVisitorGroupInstallers })]
});

export const mockVisitorCleaner = generateMockVisitor({
  id: 'mockVisitorId2',
  name: 'Maarten van der Heijden',
  email: 'm.vanderheijden@tkhsecurity.com',
  visitorGroupMembership: [generateMockVisitorGroupMembership({ visitorGroup: mockVisitorGroupCleaners })]
});

export const mockVisitor8ExpiringTomorrow = generateMockVisitor({
  id: 'mockVisitorId8',
  name: 'Liesbeth de Hoog',
  email: 'l.dehoog@tkhsecurity.com',
  identityProvider: UserIdentityProvider.Cognito,
  isAdmin: false,
  visitorGroupMembership: [
    generateMockVisitorGroupMembership({
      role: Role.None,
      visitorGroup: mockVisitorGroupCognitoTeam,
      expirationDate: dayjs().add(1, 'day').toISOString()
    })
  ]
});

export const mockVisitor9Expired = generateMockVisitor({
  id: 'mockVisitorId9',
  name: 'Martin van Loenen',
  email: 'm.loenen@tkhsecurity.com',
  identityProvider: UserIdentityProvider.Internal,
  isAdmin: false,
  visitorGroupMembership: [
    generateMockVisitorGroupMembership({
      visitorGroup: mockVisitorGroupInternalTeam,
      expirationDate: dayjs().subtract(1, 'day').toISOString()
    })
  ]
});

export const mockVisitor10KeySharing = generateMockVisitor({
  id: 'mockVisitorId10',
  name: 'Mirella van den Broek',
  email: null,
  identityProvider: UserIdentityProvider.Internal,
  visitorGroupMembership: [
    generateMockVisitorGroupMembership({ role: Role.None, visitorGroup: mockVisitorGroupKeySharingUsers })
  ]
});

export const mockVisitor11WithCard = generateMockVisitor({
  id: 'mockVisitorId11',
  name: 'Anna de Groot',
  email: 'a.degroot@tkhsecurity.com',
  identityProvider: UserIdentityProvider.Entra,
  visitorGroupMembership: [generateMockVisitorGroupMembership({ visitorGroup: mockVisitorGroupEntraTeam })]
});

export const mockVisitor12WithBlockedCard = generateMockVisitor({
  id: 'mockVisitorId12',
  name: 'Stephanie Vogels',
  email: 's.vogels@tkhsecurity.com',
  identityProvider: UserIdentityProvider.Cognito,
  mobileDevices: [],
  visitorGroupMembership: [generateMockVisitorGroupMembership({ visitorGroup: mockVisitorGroupCardHolders })]
});

export const mockVisitorCoContractor1 = generateMockVisitor({
  id: 'mockVisitorId13',
  name: 'co-contractor1',
  email: 'co-contractor1@atlas.com',
  visitorGroupMembership: [generateMockVisitorGroupMembership({ visitorGroup: mockVisitorGroupCoContractors })]
});

export const mockVisitorCoContractor2 = generateMockVisitor({
  id: 'mockVisitorId14',
  name: 'co-contractor2',
  email: 'co-contractor2@atlas.com',
  visitorGroupMembership: [generateMockVisitorGroupMembership({ visitorGroup: mockVisitorGroupCoContractors })]
});

export const mockVisitor4 = generateMockVisitor({
  id: 'mockVisitorId4',
  name: 'Hannah Kremer',
  email: 'h.kremer@tkhsecurity.com'
});

export const mockVisitor6 = generateMockVisitor({
  id: 'mockVisitorId6',
  name: 'Leo de Leeuw',
  email: 'l.deleeuw@ictservices.com'
});

export const mockVisitor15WithoutGroup = generateMockVisitor({
  id: 'mockVisitorId15',
  name: 'Nina Willems',
  email: 'n.willems@tkhsecurity.com',
  visitorGroupMembership: []
});

export const mockVisitor16Disconnected = generateMockVisitor({
  id: 'mockVisitorId16',
  name: 'Bram Visser',
  email: 'b.visser@tkhsecurity.com',
  mobileDevices: [generateMockMobileDevice({ id: 'mockedMobileDevice16', role: 'CONFIG', isRegistered: false })]
});

export const mockVisitor17ExpiringIn24h = generateMockVisitor({
  id: 'mockVisitorId17',
  name: 'Femke Smit',
  email: 'f.smit@tkhsecurity.com',
  expirationDate: dayjs().add(12, 'hours').toISOString()
});

export const mockVisitor18ExpiringThisWeek = generateMockVisitor({
  id: 'mockVisitorId18',
  name: 'Joris Peeters',
  email: 'j.peeters@tkhsecurity.com',
  expirationDate: dayjs().add(3, 'days').toISOString()
});

export const mockVisitor19DisconnectedWithoutCard = generateMockVisitor({
  id: 'mockVisitorId19',
  name: 'Kelly Aerts',
  email: 'k.aerts@tkhsecurity.com',
  mobileDevices: [generateMockMobileDevice({ id: 'mockedMobileDevice19', role: 'ACCESS', isRegistered: false })]
});

export const mockVisitor20Inactive = generateMockVisitor({
  id: 'mockVisitorId20',
  name: 'Ruben Maes',
  email: 'r.maes@tkhsecurity.com',
  mobileDevices: []
});

export const mockVisitorsInstallersAndCleaners = [
  mockVisitorInstaller,
  mockVisitorInstaller2,
  mockVisitorCleaner,
  mockVisitorCoContractor1,
  mockVisitorCoContractor2,
  mockVisitor8ExpiringTomorrow,
  mockVisitor9Expired,
  mockVisitor10KeySharing,
  mockVisitor11WithCard,
  mockVisitor12WithBlockedCard
];

export const mockVisitor1 = mockVisitorInstaller;

export const mockVisitor2 = mockVisitorCleaner;

export const mockVisitor3WithGroups = generateMockVisitor({
  id: 'mockVisitorId3',
  name: 'Grzegorz Brzęczyszczykiewicz',
  email: 'g.brzeczyszczykiewicz@tkhsecurity.com',
  visitorGroupMembership: [
    generateMockVisitorGroupMembership({ role: Role.ExternalGroupUser, visitorGroup: mockVisitorGroupAlpha }),
    generateMockVisitorGroupMembership({ role: Role.ExternalGroupUser, visitorGroup: mockVisitorGroupBeta }),
    generateMockVisitorGroupMembership({ role: Role.ExternalGroupUser, visitorGroup: mockVisitorGroupGamma })
  ]
});

export const mockVisitor5WithGroups = generateMockVisitor({
  id: 'mockVisitorId5',
  name: 'Sophie Bakker',
  email: 's.bakker@tkhsecurity.com',
  visitorGroupMembership: [
    generateMockVisitorGroupMembership({ role: Role.ExternalGroupUser, visitorGroup: mockVisitorGroupDelta }),
    generateMockVisitorGroupMembership({ role: Role.ExternalGroupUser, visitorGroup: mockVisitorGroupEpsilon }),
    generateMockVisitorGroupMembership({ role: Role.ExternalGroupUser, visitorGroup: mockVisitorGroupZeta }),
    generateMockVisitorGroupMembership({ role: Role.ExternalGroupUser, visitorGroup: mockVisitorGroupEta }),
    generateMockVisitorGroupMembership({ role: Role.ExternalGroupUser, visitorGroup: mockVisitorGroupTheta })
  ]
});

export const mockVisitor7WithGroups = generateMockVisitor({
  id: 'mockVisitorId7',
  name: 'Wouter Jansen',
  email: 'w.jansen@tkhsecurity.com',
  visitorGroupMembership: [
    generateMockVisitorGroupMembership({ role: Role.ExternalGroupUser, visitorGroup: mockVisitorGroupIota }),
    generateMockVisitorGroupMembership({ role: Role.ExternalGroupUser, visitorGroup: mockVisitorGroupKappa }),
    generateMockVisitorGroupMembership({ role: Role.ExternalGroupUser, visitorGroup: mockVisitorGroupLambda }),
    generateMockVisitorGroupMembership({ role: Role.ExternalGroupUser, visitorGroup: mockVisitorGroupMu }),
    generateMockVisitorGroupMembership({ role: Role.ExternalGroupUser, visitorGroup: mockVisitorGroupNu }),
    generateMockVisitorGroupMembership({ role: Role.ExternalGroupUser, visitorGroup: mockVisitorGroupXi }),
    generateMockVisitorGroupMembership({ role: Role.ExternalGroupUser, visitorGroup: mockVisitorGroupOmicron })
  ]
});

export const mockVisitorsWithGroups = [
  mockVisitor1,
  mockVisitor2,
  mockVisitorInstaller2,
  mockVisitor3WithGroups,
  mockVisitor4,
  mockVisitor5WithGroups,
  mockVisitor6,
  mockVisitor7WithGroups,
  mockVisitor8ExpiringTomorrow,
  mockVisitor9Expired,
  mockVisitor10KeySharing,
  mockVisitor11WithCard,
  mockVisitor12WithBlockedCard,
  mockVisitor15WithoutGroup,
  mockVisitor16Disconnected,
  mockVisitor17ExpiringIn24h,
  mockVisitor18ExpiringThisWeek,
  mockVisitor19DisconnectedWithoutCard,
  mockVisitor20Inactive
];
